module.exports = __webpack_public_path__ + "static/media/other.bc5160f3.svg";